(() => {
  const header = document.querySelector('[data-ergosia-header]');
  if (!header) return;
  const toggle = header.querySelector('[data-ergosia-menu-toggle]');
  const drawer = document.querySelector('[data-ergosia-menu-drawer]');
  const overlay = document.querySelector('[data-ergosia-menu-overlay]');
  const closeButton = drawer && drawer.querySelector('[data-ergosia-menu-close]');
  const searchToggle = header.querySelector('[data-ergosia-search-toggle]');
  const searchPanel = document.querySelector('[data-ergosia-search-panel]');

  const setMenu = (open) => {
    if (!drawer || !overlay || !toggle) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    overlay.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('ergosia-menu-open', open);
    if (open) closeButton?.focus(); else toggle.focus();
  };
  toggle?.addEventListener('click', () => setMenu(true));
  closeButton?.addEventListener('click', () => setMenu(false));
  overlay?.addEventListener('click', () => setMenu(false));
  drawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));

  searchToggle?.addEventListener('click', () => {
    const open = searchPanel.hidden;
    searchPanel.hidden = !open;
    searchToggle.setAttribute('aria-expanded', String(open));
    if (open) searchPanel.querySelector('input')?.focus();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (drawer?.classList.contains('is-open')) setMenu(false);
    if (searchPanel && !searchPanel.hidden) {
      searchPanel.hidden = true;
      searchToggle?.setAttribute('aria-expanded', 'false');
      searchToggle?.focus();
    }
  });
})();
